/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#Community
 */
var Community = 'http://rdfs.org/sioc/ns#Community';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#Container
 */
var Container = 'http://rdfs.org/sioc/ns#Container';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#Forum
 */
var Forum = 'http://rdfs.org/sioc/ns#Forum';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#Item
 */
var Item = 'http://rdfs.org/sioc/ns#Item';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#Post
 */
var Post = 'http://rdfs.org/sioc/ns#Post';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#Role
 */
var Role = 'http://rdfs.org/sioc/ns#Role';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#Space
 */
var Space = 'http://rdfs.org/sioc/ns#Space';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#Site
 */
var Site = 'http://rdfs.org/sioc/ns#Site';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#Thread
 */
var Thread = 'http://rdfs.org/sioc/ns#Thread';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#UserAccount
 */
var UserAccount = 'http://rdfs.org/sioc/ns#UserAccount';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#Usergroup
 */
var Usergroup = 'http://rdfs.org/sioc/ns#Usergroup';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#about
 */
var about = 'http://rdfs.org/sioc/ns#about';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#account_of
 */
var account_of = 'http://rdfs.org/sioc/ns#account_of';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#addressed_to
 */
var addressed_to = 'http://rdfs.org/sioc/ns#addressed_to';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#administrator_of
 */
var administrator_of = 'http://rdfs.org/sioc/ns#administrator_of';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#attachment
 */
var attachment = 'http://rdfs.org/sioc/ns#attachment';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#avatar
 */
var avatar = 'http://rdfs.org/sioc/ns#avatar';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#container_of
 */
var container_of = 'http://rdfs.org/sioc/ns#container_of';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#content
 */
var content = 'http://rdfs.org/sioc/ns#content';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#creator_of
 */
var creator_of = 'http://rdfs.org/sioc/ns#creator_of';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#delivered_at
 */
var delivered_at = 'http://rdfs.org/sioc/ns#delivered_at';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#discussion_of
 */
var discussion_of = 'http://rdfs.org/sioc/ns#discussion_of';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#email
 */
var email = 'http://rdfs.org/sioc/ns#email';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#email_sha1
 */
var email_sha1 = 'http://rdfs.org/sioc/ns#email_sha1';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#embeds_knowledge
 */
var embeds_knowledge = 'http://rdfs.org/sioc/ns#embeds_knowledge';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#feed
 */
var feed = 'http://rdfs.org/sioc/ns#feed';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#follows
 */
var follows = 'http://rdfs.org/sioc/ns#follows';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#function_of
 */
var function_of = 'http://rdfs.org/sioc/ns#function_of';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#generator
 */
var generator = 'http://rdfs.org/sioc/ns#generator';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#has_administrator
 */
var has_administrator = 'http://rdfs.org/sioc/ns#has_administrator';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#has_container
 */
var has_container = 'http://rdfs.org/sioc/ns#has_container';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#has_creator
 */
var has_creator = 'http://rdfs.org/sioc/ns#has_creator';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#has_discussion
 */
var has_discussion = 'http://rdfs.org/sioc/ns#has_discussion';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#has_function
 */
var has_function = 'http://rdfs.org/sioc/ns#has_function';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#has_host
 */
var has_host = 'http://rdfs.org/sioc/ns#has_host';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#has_member
 */
var has_member = 'http://rdfs.org/sioc/ns#has_member';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#has_moderator
 */
var has_moderator = 'http://rdfs.org/sioc/ns#has_moderator';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#has_modifier
 */
var has_modifier = 'http://rdfs.org/sioc/ns#has_modifier';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#has_owner
 */
var has_owner = 'http://rdfs.org/sioc/ns#has_owner';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#has_parent
 */
var has_parent = 'http://rdfs.org/sioc/ns#has_parent';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#has_reply
 */
var has_reply = 'http://rdfs.org/sioc/ns#has_reply';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#has_scope
 */
var has_scope = 'http://rdfs.org/sioc/ns#has_scope';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#has_space
 */
var has_space = 'http://rdfs.org/sioc/ns#has_space';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#has_subscriber
 */
var has_subscriber = 'http://rdfs.org/sioc/ns#has_subscriber';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#has_usergroup
 */
var has_usergroup = 'http://rdfs.org/sioc/ns#has_usergroup';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#host_of
 */
var host_of = 'http://rdfs.org/sioc/ns#host_of';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#id
 */
var id = 'http://rdfs.org/sioc/ns#id';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#ip_address
 */
var ip_address = 'http://rdfs.org/sioc/ns#ip_address';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#last_activity_date
 */
var last_activity_date = 'http://rdfs.org/sioc/ns#last_activity_date';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#last_item_date
 */
var last_item_date = 'http://rdfs.org/sioc/ns#last_item_date';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#last_reply_date
 */
var last_reply_date = 'http://rdfs.org/sioc/ns#last_reply_date';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#latest_version
 */
var latest_version = 'http://rdfs.org/sioc/ns#latest_version';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#likes
 */
var likes = 'http://rdfs.org/sioc/ns#likes';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#link
 */
var link = 'http://rdfs.org/sioc/ns#link';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#links_to
 */
var links_to = 'http://rdfs.org/sioc/ns#links_to';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#member_of
 */
var member_of = 'http://rdfs.org/sioc/ns#member_of';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#mentions
 */
var mentions = 'http://rdfs.org/sioc/ns#mentions';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#moderator_of
 */
var moderator_of = 'http://rdfs.org/sioc/ns#moderator_of';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#modifier_of
 */
var modifier_of = 'http://rdfs.org/sioc/ns#modifier_of';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#name
 */
var name = 'http://rdfs.org/sioc/ns#name';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#next_by_date
 */
var next_by_date = 'http://rdfs.org/sioc/ns#next_by_date';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#next_version
 */
var next_version = 'http://rdfs.org/sioc/ns#next_version';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#note
 */
var note = 'http://rdfs.org/sioc/ns#note';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#num_authors
 */
var num_authors = 'http://rdfs.org/sioc/ns#num_authors';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#num_items
 */
var num_items = 'http://rdfs.org/sioc/ns#num_items';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#num_replies
 */
var num_replies = 'http://rdfs.org/sioc/ns#num_replies';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#num_threads
 */
var num_threads = 'http://rdfs.org/sioc/ns#num_threads';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#num_views
 */
var num_views = 'http://rdfs.org/sioc/ns#num_views';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#owner_of
 */
var owner_of = 'http://rdfs.org/sioc/ns#owner_of';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#parent_of
 */
var parent_of = 'http://rdfs.org/sioc/ns#parent_of';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#previous_by_date
 */
var previous_by_date = 'http://rdfs.org/sioc/ns#previous_by_date';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#previous_version
 */
var previous_version = 'http://rdfs.org/sioc/ns#previous_version';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#read_at
 */
var read_at = 'http://rdfs.org/sioc/ns#read_at';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#related_to
 */
var related_to = 'http://rdfs.org/sioc/ns#related_to';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#reply_of
 */
var reply_of = 'http://rdfs.org/sioc/ns#reply_of';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#respond_to
 */
var respond_to = 'http://rdfs.org/sioc/ns#respond_to';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#scope_of
 */
var scope_of = 'http://rdfs.org/sioc/ns#scope_of';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#shared_by
 */
var shared_by = 'http://rdfs.org/sioc/ns#shared_by';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#space_of
 */
var space_of = 'http://rdfs.org/sioc/ns#space_of';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#subscriber_of
 */
var subscriber_of = 'http://rdfs.org/sioc/ns#subscriber_of';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#topic
 */
var topic = 'http://rdfs.org/sioc/ns#topic';
/**
 *
 *
 *
 *
 * http://rdfs.org/sioc/ns#usergroup_of
 */
var usergroup_of = 'http://rdfs.org/sioc/ns#usergroup_of';

var siocImport = /*#__PURE__*/Object.freeze({
	Community: Community,
	Container: Container,
	Forum: Forum,
	Item: Item,
	Post: Post,
	Role: Role,
	Space: Space,
	Site: Site,
	Thread: Thread,
	UserAccount: UserAccount,
	Usergroup: Usergroup,
	about: about,
	account_of: account_of,
	addressed_to: addressed_to,
	administrator_of: administrator_of,
	attachment: attachment,
	avatar: avatar,
	container_of: container_of,
	content: content,
	creator_of: creator_of,
	delivered_at: delivered_at,
	discussion_of: discussion_of,
	email: email,
	email_sha1: email_sha1,
	embeds_knowledge: embeds_knowledge,
	feed: feed,
	follows: follows,
	function_of: function_of,
	generator: generator,
	has_administrator: has_administrator,
	has_container: has_container,
	has_creator: has_creator,
	has_discussion: has_discussion,
	has_function: has_function,
	has_host: has_host,
	has_member: has_member,
	has_moderator: has_moderator,
	has_modifier: has_modifier,
	has_owner: has_owner,
	has_parent: has_parent,
	has_reply: has_reply,
	has_scope: has_scope,
	has_space: has_space,
	has_subscriber: has_subscriber,
	has_usergroup: has_usergroup,
	host_of: host_of,
	id: id,
	ip_address: ip_address,
	last_activity_date: last_activity_date,
	last_item_date: last_item_date,
	last_reply_date: last_reply_date,
	latest_version: latest_version,
	likes: likes,
	link: link,
	links_to: links_to,
	member_of: member_of,
	mentions: mentions,
	moderator_of: moderator_of,
	modifier_of: modifier_of,
	name: name,
	next_by_date: next_by_date,
	next_version: next_version,
	note: note,
	num_authors: num_authors,
	num_items: num_items,
	num_replies: num_replies,
	num_threads: num_threads,
	num_views: num_views,
	owner_of: owner_of,
	parent_of: parent_of,
	previous_by_date: previous_by_date,
	previous_version: previous_version,
	read_at: read_at,
	related_to: related_to,
	reply_of: reply_of,
	respond_to: respond_to,
	scope_of: scope_of,
	shared_by: shared_by,
	space_of: space_of,
	subscriber_of: subscriber_of,
	topic: topic,
	usergroup_of: usergroup_of
});

export { link as $, has_host as A, has_member as B, Community as C, has_moderator as D, has_modifier as E, Forum as F, has_owner as G, has_parent as H, Item as I, has_reply as J, has_scope as K, has_space as L, has_subscriber as M, has_usergroup as N, host_of as O, Post as P, id as Q, Role as R, Space as S, Thread as T, UserAccount as U, ip_address as V, last_activity_date as W, last_item_date as X, last_reply_date as Y, latest_version as Z, likes as _, Container as a, links_to as a0, member_of as a1, mentions as a2, moderator_of as a3, modifier_of as a4, name as a5, next_by_date as a6, next_version as a7, note as a8, num_authors as a9, num_items as aa, num_replies as ab, num_threads as ac, num_views as ad, owner_of as ae, parent_of as af, previous_by_date as ag, previous_version as ah, read_at as ai, related_to as aj, reply_of as ak, respond_to as al, scope_of as am, shared_by as an, space_of as ao, subscriber_of as ap, topic as aq, usergroup_of as ar, siocImport as as, Site as b, Usergroup as c, about as d, account_of as e, addressed_to as f, administrator_of as g, attachment as h, avatar as i, container_of as j, content as k, creator_of as l, delivered_at as m, discussion_of as n, email as o, email_sha1 as p, embeds_knowledge as q, feed as r, follows as s, function_of as t, generator as u, has_administrator as v, has_container as w, has_creator as x, has_discussion as y, has_function as z };
